import React, { FC } from "react";
import { StyledAccordionTitle, StyledArrow, StyledAccordionButton } from "../styled";

interface Props {
  title: React.ReactNode;
  isOpen: boolean;
  onClick?: () => void;
}

export const AccordionTitle: FC<Props> = ({ title, isOpen, onClick }) => (
  <StyledAccordionTitle onClick={onClick}>
    <StyledArrow isOpen={isOpen} />
    {typeof title === "string" ? (
      <StyledAccordionButton onClick={onClick}>{title}</StyledAccordionButton>
    ) : (
      <>{title}</>
    )}
  </StyledAccordionTitle>
);
